<template>
  <div>
    <b-row>
      <b-col
        md="12"
        class="mb-2 "
        style="color:#9e9e9e; text-align:center; font-size: 12px;font-weight: bold"
      >
        Grupo {{ dataGrupo.grupo }}</b-col
      >
      <b-col md="2" class="d-none align-items-center;">
        <b-form-checkbox v-model="checkActiva">
          <p style="font-size:10px;color:gray !important">
            Activa
          </p>
        </b-form-checkbox></b-col
      >
      <b-col md="4">
        <div class="form-label-group">
          <b-form-input
            v-model="dataGrupo.nombreGrupo"
            placeholder="Nombre Grupo"
            type="text"
            size="sm"
          />
          <label for="floating-apellido">Nombre grupo</label>
        </div>
      </b-col>

      <b-col md="4">
        <div class="form-label-group">
          <b-form-input
            v-model="dataGrupo.estado_fixture"
            placeholder="Fixture"
            type="text"
            size="sm"
          />
          <label for="floating-apellido">Estado Fixture</label>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import { ref, watch } from '@vue/composition-api'
import {
  BRow,
  BCol,
  BFormCheckbox,
  BFormInput,
  //   BFormGroup,
  // xx
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BFormCheckbox,
    BFormInput,
    // BFormGroup,
  },
  directives: {
    Ripple,
  },
  props: {
    dataGrupo: Object,
  },
  setup(props) {
    // eslint-disable-next-line
    const checkActiva = ref(props.dataGrupo.estado === 'a' ? true : false)

    watch(checkActiva, despues => {
      if (despues) {
        props.dataGrupo.estado = 'a'
      } else {
        props.dataGrupo.estado = 'd'
      }
    })

    return {
      checkActiva,
    }
  },
}
</script>

<style></style>
